var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { ref: "bank-details", attrs: { "lazy-validation": "" } },
    [
      _c(
        "v-row",
        { staticClass: "px-5" },
        [
          _c(
            "v-col",
            { staticClass: "hint-label pt-0 my-3", attrs: { cols: "12" } },
            [
              _vm._v(
                "Ihre Bankverbindung nutzen wir nur, sofern Ihr Antrag positiv entschieden wird!"
              ),
              _c("br"),
              _vm._v(
                "\nGVL-Mitglieder möchten bitte nach Möglichkeit die bereits bei uns hinterlegte IBAN angeben."
              )
            ]
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v("16. Vorname Name (wie bei Überweisungen angegeben)")
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.bank_vorname_name))
                  ])
                : _c("v-text-field", {
                    attrs: {
                      autocomplete: "off",
                      outlined: "",
                      dense: "",
                      rules: [_vm.rules.required]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("bank_vorname_name", v)
                      }
                    },
                    model: {
                      value: _vm.formData.bank_vorname_name,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "bank_vorname_name", $$v)
                      },
                      expression: "formData.bank_vorname_name"
                    }
                  })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v("17. IBAN")
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.bank_iban))
                  ])
                : _c("v-text-field", {
                    staticClass: "upper-text",
                    attrs: {
                      autocomplete: "off",
                      outlined: "",
                      dense: "",
                      rules: [_vm.rules.required, _vm.rules.valid_iban]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("bank_iban", v)
                      }
                    },
                    model: {
                      value: _vm.formData.bank_iban,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "bank_iban", $$v)
                      },
                      expression: "formData.bank_iban"
                    }
                  })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v("18. BIC")
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.bank_bic))
                  ])
                : _c("v-text-field", {
                    staticClass: "upper-text",
                    attrs: {
                      autocomplete: "off",
                      outlined: "",
                      dense: "",
                      rules: [
                        _vm.rules.required,
                        _vm.rules.valid_regexp(/[A-Z0-9]+/i),
                        _vm.rules.valid_bic
                      ]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("bank_bic", v)
                      }
                    },
                    model: {
                      value: _vm.formData.bank_bic,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "bank_bic", $$v)
                      },
                      expression: "formData.bank_bic"
                    }
                  })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }